import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const render: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),

  h3: {
    fontSize: responsive({ 0: 16, 3: 19 }),
  },

  '.tabs__render__child': {
    boxShadow: 'tabs',
  },
};

export default render;
